import { useMutation, useQueryClient } from "@tanstack/react-query";

import type { LogEntryReference } from "@apis/calorie-grid/models";
import { LogEntry } from "@apis/calorie-grid/models";

import { logEntryRepository } from "../../repository/LogEntryRepository.ts";
import { useAuth } from "../contexts/auth/useAuth.ts";
import { useConfig } from "../contexts/config/useConfig.ts";

import { useQueries } from "./useQueries.ts";

// oxlint-disable-next-line @typescript-eslint/explicit-function-return-type
export function useLogEntryActions() {
  const { userId } = useAuth();

  const { gridEpochId } = useConfig();

  const queryClient = useQueryClient();
  const { getLogEntriesQueryOptions } = useQueries();
  const invalidateLogEntries = async (): Promise<void> => {
    const logEntriesQueryOptions = getLogEntriesQueryOptions();

    await queryClient.invalidateQueries({
      queryKey: logEntriesQueryOptions.groupQueryKey,
    });
  };

  const createLogEntry = useMutation({
    mutationFn: async ({
      name,
      product,
      totalCalories,
      weightGrams,
    }: {
      readonly name: string;
      readonly product: LogEntryReference;
      readonly totalCalories: number;
      readonly weightGrams?: null | number;
    }): Promise<void> => {
      await logEntryRepository.create(
        LogEntry.create({
          gridEpochId,
          name,
          product,
          status: "pending",
          totalCalories,
          userId,
          weightGrams,
        }),
      );
    },
    onSuccess: invalidateLogEntries,
  });

  return { createLogEntry, invalidateLogEntries };
}
